import { captureMessage } from "@sentry/browser";

type SafeCallbackOptions = {
	logErrors?: boolean;
};

export function safeCallback<T>(callback: () => T | null | undefined, settings?: SafeCallbackOptions): T | null {
	try {
		return callback() ?? null;
	} catch (error) {
		if (settings?.logErrors) {
			captureMessage(`Error in safeCallback: ${error instanceof Error ? error.message : String(error)}`, "error");
		}
		return null;
	}
}
